import { ApiService } from "@/services/api/ApiService";
import type { AdminSlackApp } from "@/types/admin/slack-apps";

export class SlackAppAdminService {
  static async list(): Promise<AdminSlackApp[]> {
    const response = await ApiService.invoke<{ apps: AdminSlackApp[] }>({
      resource: "chat-channels",
      action: "own-app-admin-list",
    });
    return response?.apps ?? [];
  }
}
